<script setup lang="ts">
import { createInput } from '@formkit/vue'
import AddressInput from './CreateInputBase/Address.vue'

const addressInput = createInput(AddressInput, { props: ['placeholder', 'disabled'] })
</script>

<template>
  <FormKit :type="addressInput" />
</template>
